export const LogoVariants = {
  default: "logo.svg",
  white: "logo-white.svg",
  defaultWithText: "logo-text.svg",
  whiteWithText: "logo-white-text.svg",
};

export const Logo = ({
  alt = "Logo",
  variant = LogoVariants.default,
  ...args
}) => {
  const src = `${process.env.PUBLIC_URL}/${variant}`;

  return <img src={src} alt={alt} {...args} />;
};

Logo.variants = LogoVariants;
